import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Lock, Unlock } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, money } from "@/lib/api";
import { Button } from "@/components/ui/button";
import TxTable from "@/components/TxTable";

export default function CardDetail() {
  const { id } = useParams();
  const [card, setCard] = useState(null);
  const [k, setK] = useState(0);
  useEffect(() => { api.get(`/cards/${id}`).then((r) => setCard(r.data)); }, [id]);

  const toggle = async () => {
    try {
      const r = await api.post(`/cards/${id}/lock`, { locked: !card.locked });
      setCard(r.data); setK(k + 1);
      toast.success(r.data.locked ? "Card locked" : "Card unlocked");
    } catch (e) { toast.error(errMsg(e)); }
  };

  if (!card) return <div className="text-slate-500">Loading...</div>;
  return (
    <div data-testid="card-detail">
      <Link to="/" className="inline-flex items-center gap-1 text-sm font-semibold text-[var(--blue)] mb-6"><ArrowLeft size={15} /> All accounts</Link>
      <div className="grid lg:grid-cols-[380px_1fr] gap-8 mb-10">
        <div className={`rounded-2xl p-7 text-white bg-[var(--navy)] relative overflow-hidden aspect-[1.586] fade-up ${card.locked ? "grayscale opacity-80" : ""}`} data-testid="card-visual">
          <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-[var(--red)]" />
          <div className="absolute -right-16 top-16 h-40 w-40 rounded-full bg-[var(--blue)]" />
          <div className="relative font-display font-bold">Maderian</div>
          <div className="relative mt-14 font-mono tracking-[0.2em] text-lg">•••• •••• •••• {card.number_last4}</div>
          <div className="relative mt-3 text-sm opacity-80">{card.name}</div>
          {card.locked && <div className="absolute bottom-5 right-5 flex items-center gap-1 text-xs font-semibold bg-white text-[var(--red)] rounded-full px-3 py-1"><Lock size={12} /> LOCKED</div>}
        </div>
        <div className="tile">
          <div className="p-7 grid sm:grid-cols-3 gap-6">
            <div><div className="text-xs text-slate-500">Current balance</div><div className="text-3xl font-display font-bold text-[var(--navy)]" data-testid="card-detail-balance">{money(card.balance)}</div></div>
            <div><div className="text-xs text-slate-500">Credit limit</div><div className="text-xl font-display font-semibold">{money(card.credit_limit)}</div></div>
            <div><div className="text-xs text-slate-500">Available credit</div><div className="text-xl font-display font-semibold">{money(card.credit_limit - card.balance)}</div></div>
          </div>
          <div className="px-7 pb-7 flex flex-wrap gap-3">
            <Button onClick={toggle} className={`rounded-full ${card.locked ? "bg-emerald-600 hover:bg-emerald-700" : "bg-[var(--red)] hover:bg-[#a50d26]"}`} data-testid="card-detail-lock-toggle">
              {card.locked ? <><Unlock size={15} className="mr-1" /> Unlock card</> : <><Lock size={15} className="mr-1" /> Lock card</>}
            </Button>
            <Link to={`/transfer?tab=internal&card=${card.id}`}><Button variant="outline" className="rounded-full" data-testid="card-pay-button">Pay card</Button></Link>
          </div>
        </div>
      </div>
      <h2 className="text-lg font-bold text-[var(--navy)] mb-4">Card activity</h2>
      <TxTable cardId={id} refreshKey={k} />
    </div>
  );
}
